/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Sales {

    import fld = MaterialOutItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialOutItemsEditor extends _Ext.ItemGridEditor<MaterialOutItemsRow> {


        protected getColumnsKey() { return "Sales.MaterialOutItems"; }
        protected getDialogType() { return MaterialOutItemsDialog; }
        protected getLocalTextPrefix() { return MaterialOutItemsRow.localTextPrefix; }
        protected form: MaterialOutItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        public TransDate: Date;  
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });

        }
      
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            //Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup());
             
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

         
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item); 
                        this.view.deleteItem(id);

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        let values;

                        var input = $(e.target);
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        }
                       
                    }

                    this.view.refresh();
                }
            }
        }
        setData(Items) {
            //set data in Material Grid from Job Work

            let BOMdetails;
            for (let item of Items) {
                BOMdetails = item.BOMDetails;

                 
                for (let BOM of BOMdetails) {
                    var detail: Sales.MaterialOutItemsRow = {
                        AttributeId: BOM.BOMAttributeId,
                        ProductCode: BOM.ProductCode,
                        ProductId: BOM.ProductId,
                        ProductName: BOM.ProductName,
                        SKU: item.SKU,
                        Line_No: item.Line_No,
                        Pieces: BOM.Pieces,
                        Weight: BOM.Weight,
                        HSN: item.HSN
                    };
                    detail[this.getIdProperty()] = "`" + this.nextId++;
                    this.view.addItem(detail);

                }
            }
        }

        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let _value = ValidateEditorFields(field, input, text, oldText);
            let value: number;
            if (q.isNumber(_value))
                value = parseFloat(_value.toString());
            else
                return false;


            let CurrentStock: Stock.StockItemRow;

            Stock.StockItemService.GetProductDetails({
                ProductId: item.ProductId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                LotNo: item.LotNo,
                TransId: item.TransId,
                TransItemId: item.TransItemId
            },
                response =>
                    CurrentStock = response.Entity,
                { async: false }
            );
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                if (value > CurrentStock.Pieces) {
                    Q.alert('Not Enough Stock');
                    item[field] = CurrentStock.Pieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;
                }
                item[field] = value;
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {
                if (value > CurrentStock.Weight) {
                    Q.alert('Not Enough Stock');
                    item[field] = CurrentStock.Weight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId != 3) {
                    var Net = ((item.UnitRate + item.UnitLabour) / item.Weight) * value;
                    item.NetAmount = Net; 
                    item.GrossAmount = Net  ;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }
            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();


            let returnvalue: string = "";
            if (input.hasClass('numeric'))
                returnvalue = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                returnvalue = Q.formatNumber(value, '0');

            input.val(returnvalue).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.StockSelectGrid;
            buttons = buttons.filter(x => x.cssClass != "add-button");
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "alt+k",
                onClick: () => {

                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                  
                    else { 
                        var filters: _Ext.SelectGridFilters = {
                            FilterItems:4
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    } 
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetSalesItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setGridData(ItemDetails);
                    } 
                    pickerDialog.dialogOpen();
                }
            }); 
            return buttons;
        }


        setGridData(ItemDetails: any[]) {
            for (let Itemdetail of ItemDetails) {
                var Item = Itemdetail;
                var SalesItem: Sales.MaterialOutItemsRow = {
                    ProductId: Item.ProductId,
                    AttributeId: Item.AttributeId,
                    Attribute: Item.Attribute,
                    Line_No: Item.Line_No == null ? Item.LineNo : Item.Line_No,
                    SKU: Item.SKU,
                    DepartmentId: Item.DepartmentId,
                    DeptName: Item.DeptName,
                    ProductCode: Item.ProductCode,
                    ProductName: Item.ProductName,
                    ItemTypeId: Item.ItemTypeId,
                    HasBom: Item.HasBom,
                    CategoryId: Item.CategoryId,
                    ProductTypeId: Item.ProductTypeId,
                    SubCategoryId: Item.SubCategoryId,
                    BrandId: Item.BrandId,
                    SuperTypeId: Item.SuperTypeId,
                    CollectionId: Item.CollectionId,
                    UnitRate: Item.Rate,
                    UnitLabour: Item.LaborRate,
                    UnitCost: Item.Cost,
                    Pieces: Item.Pieces >= 0 ? Item.Pieces : 1,
                    Weight: Item.Weight,
                    OtherPieces: Item.OtherPieces,
                    OtherWeight: Item.OtherWeight,
                    StonePieces: Item.StonePieces,
                    StoneWeight: Item.StoneWeight,
                    NetWeight: Item.NetWeight,
                    NetAmount: Item.Amount,
                    GrossAmount: Item.Amount,
                    DiamondPieces: Item.DiamondPieces,
                    DiamondWeight: Item.DiamondWeight,
                    CalcOnId: Item.CalcOnId,
                    BOMDetails: Item.BOMDetails,
                    CompanyId: Item.CompanyId,
                    HSN: Item.HSN,
                    TaxCode: Item.TaxCode,
                    MetalId: Item.MetalId,
                    KaratId: Item.ItemTypeId == 101 ? Item.KaratId : Item.KaratId,
                    MetalColorId: Item.MetalColorId,
                    QualityId: Item.QualityId,
                    SieveId: Item.SieveId,
                    ShapeId: Item.ShapeId,
                    StoneColorId: Item.StoneColorId,
                    StoneSizeId: Item.StoneSizeId,
                    ImageName: Item.ImageName,
                    Studded: Item.Studded, // marking item as bulk
                    StoneCutId: Item.StoneCutId,
                    StonePolishId: Item.StonePolishId,
                    StoneSymmetryId: Item.StoneSymmetryId,
                    StoneFluorescenceId: Item.StoneFluorescenceId,
                    StoneCuletId: Item.StoneCuletId,
                    StoneGirdleId: Item.StoneGirdleId,
                    StoneTable: Item.StoneTable,
                    StoneDepth: Item.StoneDepth,
                    Purity: Item.Purity,
                    CalcUnitId: Item.CalcUnitId,
                    PureWeight: Item.Weight * Item.Purity,
                    RefVoucherId: Item.RefVoucherId,
                    RefTransId: Item.RefTransId,
                    RefTransItemId: Item.RefTransItemId,
                    CCGrossAmount: Item.Amount * Item.ExchangeRate,
                    CCNetAmount: Item.Amount * Item.ExchangeRate,
                    LotNo: Item.LotNo,
                    CertificateNo: Item.CertificateNo,
                    BagNo: Item.BagNo,
                    Lab: Item.Lab,
                    

                };


                SalesItem[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(SalesItem);
            }
        }
    }
}